export default "__VITE_ASSET__60908fcb__"